/**
 * L2-P3: moved to @miq/platform (resolvers/entity-display.resolver.ts). This shim keeps the old import
 * path working; new code should import from '@miq/platform'.
 */
export { entityDisplayResolver, EntityDisplayResolver } from '@miq/platform';
